/**
 * ローコントラストカラープリセット
 * 彩度を落とし、柔らかい印象にする
 */

import type { ColorPreset } from './types';

export const LOW_CONTRAST_PRESET: ColorPreset = {
  base: {
    WHITE: '#fafafa',
    BLACK: '#262626',
    GRAY: '#a6a6a6',
    LIGHT_GRAY: '#f0f0f0',
    BORDER: '#d4d4d4',
    TEXT: 'rgba(0, 0, 0, 0.95)',
    TEXT_SECONDARY: 'rgba(0, 0, 0, 0.55)',
  },
  theme: {
    PRIMARY: '#69c0ff',
    PRIMARY_DARK: '#40a9ff',
    SUCCESS: '#95de64',
    WARNING: '#ffd666',
    ERROR: '#cc5f5f',
    INFO: '#69c0ff',
  },
  darkTheme: {
    BACKGROUND: '#1f1f1f',
    BORDER: '#303030',
    TEXT: '#f0f0f0',
  },
  status: {
    ACTIVE: '#95de64',
    STOPPED: '#a6a6a6',
    WARNING: '#ffd666',
    ERROR: '#cc5f5f',
  },
  chart: {
    SERIES_1: '#cc5f5f',
    SERIES_2: '#69c0ff',
    SERIES_3: '#95de64',
    SERIES_4: '#ffd666',
    SERIES_5: '#b37feb',
    SERIES_6: '#5cdbd3',
    SERIES_7: '#ff85c0',
    SERIES_8: '#c48080',
    SERIES_9: '#ffc069',
    NO_DATA_MASK: 'rgba(180, 180, 180, 0.15)',
  },
  logLevel: {
    INFO: '#69c0ff',
    WARNING: '#ffd666',
    ERROR: '#cc5f5f',
  },
  statistic: {
    TOTAL: '#69c0ff',
    ACTIVE: '#95de64',
    INACTIVE: '#a6a6a6',
    WARNING: '#ffd666',
  },
  feedbackBackground: {
    ERROR_BG: '#ffe8e0',
    ERROR_LIGHT: '#fff7f0',
    SUCCESS_LIGHT: '#f9ffe6',
  },
} as const;
